import { OnSchedRest } from "../../OnSchedRest";


const ValidateStripe = element => {
  let stripeValidation = {
    payment_valid: false,
    connected_account: false,
    paymentOptions: {},
    payment_url: element.onsched.apiBaseUrl.replace('/consumer', '/payment'), // Replace "/consumer" with "/payment" for hidden API interface
  };

  if (element.options.payments === true) {
    if (element.options.paymentOptions) {
      const { paymentOptions } = element.options
      // Check payment provider
      switch (paymentOptions.provider) {
        case 'stripe':
          stripeValidation.payment_valid = true;
          stripeValidation.payment_url += '/stripepayments/paymentintents';
          // Check if using Stripe Connect feature
          stripeValidation.connected_account = paymentOptions.connectedAccount ? true : false;
          break;
      }

      // Return paymentOptions in stripeValidation object
      stripeValidation.paymentOptions = paymentOptions;
      // Remove provider value from stripeValidation object
      delete stripeValidation.provider
    }
    else {
      console.log('No payment options found. Include paymentOptions object in element options with relevant payment details.')
    }
  }

  return stripeValidation;
}

export const StripePaymentElement = element => {
  const el = document.getElementById(element.id);
  // Validate stripe options
  const stripeValidation = ValidateStripe(element);
  var stripeData = {};

  // Check for valid payment options
  if (stripeValidation.payment_valid) {
    // Create payment intent
    OnSchedRest.Post(stripeValidation.payment_url, stripeValidation.paymentOptions, paymentIntent => {
      if (!paymentIntent.error) {
        // Payment intent succeeded
        Object.assign(stripeData, paymentIntent);

        el.dispatchEvent(new CustomEvent("paymentIntent", { detail: stripeData }));
      }
      else {
        // Error creating payment intent
        el.dispatchEvent(new CustomEvent("paymentIntent", { detail: paymentIntent }));
      }
    })
  }
  else {
    // OnSched paymentOptions values invalid
    el.dispatchEvent(new CustomEvent("paymentIntent", { detail: { error: true, code: 400, data: { errors: [{ status: 400, error: "StripePayment options object is invalid." }]}}}));
  }
}
